var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "27px",
    height: "26px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(255, 255, 255)",
    d: "M22.454,3.957 C20.042,1.539 16.829,0.209 13.415,0.209 C6.368,0.209 0.634,5.944 0.634,12.991 C0.634,15.242 1.221,17.441 2.338,19.382 L0.524,26.003 L7.301,24.224 C9.166,25.243 11.268,25.778 13.409,25.778 L13.415,25.778 C20.457,25.778 26.318,20.044 26.318,12.997 C26.318,9.582 24.867,6.376 22.454,3.957 ZM13.415,23.625 C11.504,23.625 9.633,23.113 8.003,22.145 L7.617,21.915 L3.599,22.969 L4.670,19.048 L4.416,18.645 C3.351,16.952 2.793,15.000 2.793,12.991 C2.793,7.136 7.560,2.368 13.421,2.368 C16.259,2.368 18.925,3.474 20.929,5.483 C22.932,7.493 24.164,10.158 24.159,12.997 C24.159,18.858 19.271,23.625 13.415,23.625 ZM19.242,15.668 C18.925,15.507 17.353,14.735 17.060,14.632 C16.766,14.522 16.553,14.471 16.340,14.793 C16.127,15.115 15.517,15.829 15.327,16.048 C15.142,16.261 14.952,16.290 14.636,16.129 C12.759,15.190 11.527,14.453 10.289,12.329 C9.961,11.765 10.617,11.805 11.227,10.584 C11.331,10.371 11.279,10.187 11.199,10.026 C11.118,9.865 10.479,8.293 10.214,7.654 C9.955,7.032 9.690,7.118 9.494,7.107 C9.310,7.095 9.097,7.095 8.884,7.095 C8.671,7.095 8.326,7.176 8.032,7.493 C7.738,7.815 6.915,8.586 6.915,10.158 C6.915,11.730 8.061,13.250 8.216,13.463 C8.377,13.676 10.467,16.900 13.674,18.288 C15.701,19.163 16.495,19.238 17.509,19.088 C18.125,18.996 19.397,18.317 19.662,17.568 C19.927,16.820 19.927,16.181 19.846,16.048 C19.771,15.904 19.558,15.824 19.242,15.668 Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.080fa99d49fec6bbf9457d5ebcefd49d.svg";
export { ForwardRef as ReactComponent };